import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { EXTENSIONS } from 'probonio-shared-ui/registry';
import React, { useCallback } from 'react';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { ActivationDialogExtensions } from './ActivationDialog';

export function useBoundActivationComponent<A extends object, T extends { activationDialogExtensions: ActivationDialogExtensions<A> }>(
  componentType: React.ComponentType<T>,
  benefit?: BenefitDTOBenefitEnum,
): React.ComponentType<Omit<T, 'activationDialogExtensions'>> {
  const keyedBenefitMetadataExtension = EXTENSIONS.getKeyedProviders(BenefitMetadataExtensionInterface).find(
    ({ provider }) => provider.benefitId === benefit,
  );

  const benefitActivationDialogExtension = EXTENSIONS.getProviderByKey(
    keyedBenefitMetadataExtension?.key,
    BenefitActivationDialogExtensionInterface<T>,
  );

  if (benefit && !benefitActivationDialogExtension) {
    throw new Error(`No BenefitActivationDialogExtension found for benefit: ${benefit}`);
  }

  const Component = componentType;

  const BoundComponent = useCallback<React.FC<Omit<T, 'activationDialogExtensions'>>>(
    props => {
      if (!benefitActivationDialogExtension) {
        return <></>;
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return <Component activationDialogExtensions={benefitActivationDialogExtension} {...(props as any)} />;
    },
    [Component, benefitActivationDialogExtension],
  );
  return BoundComponent;
}
